import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from '@env/environment';
import { LanguageService, Logger } from '@app/core';
import * as L from 'leaflet';
import { TimeagoModule } from 'ngx-timeago';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, TranslateModule, MatIconModule, TimeagoModule]
})
export class AppComponent implements OnInit {
  icons: Array<string> = [
    'delivery-truck',
    'recycle-bin',
    'weight',
    'beach-house',
    'businessman',
    'Group',
    'owner',
    'export-flat',
    'user-menu',
    'delivery-truck-green',
    'company',
    'delivery-truck-purple',
    'calendar-month',
    'user',
    'delivery-truck-with-circular-clock',
    'delivery-truck-gray',
    'weight-footer',
    'sort-up',
    'sort-down',
    'reorder',
    'swap-vertical',
    'error',
    //map icons
    'yellow-x',
    'yellow-2x',
    'light-green-x',
    'light-green-2x',
    'dark-green-2x',
    'dark-green-x',
    'black-x',
    'black-2x',
    'blue-x',
    'blue-2x',
    'brown-x',
    'brown-2x',
    'dark-blue-x',
    'dark-blue-2x',
    'dark-dark-green-x',
    'dark-dark-green-2x',
    'dark-gray-x',
    'dark-gray-2x',
    'dark-parple-x',
    'dark-parple-2x',
    'dark-red-x',
    'dark-red-2x',
    'dark-sky-x',
    'dark-sky-2x',
    'gray-x',
    'gray-2x',
    'light-brown-x',
    'light-brown-2x',
    'light-red-x',
    'light-red-2x',
    'orange-x',
    'orange-2x',
    'purple-x',
    'purple-2x',
    'red-x',
    'red-2x',
    'sky-x',
    'sky-2x',
    'legal-issue',
    'arrow_forward'
  ];
  constructor(
    protected router: Router,
    private titleService: Title,
    private translateService: TranslateService,
    protected languageService: LanguageService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    let DefaultIcon = L.icon({
      iconUrl: 'assets/markers/marker-icon.png'
    });

    L.Marker.prototype.options.icon = DefaultIcon;

    // L.Icon.Default.prototype.options.iconUrl = '';
    // console.log( L.Icon.Default.prototype._detectIconPath);
    this.addSvgIcons(this.icons);
    // add icon in svIcons material icons

    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }
    // this.changeTitlePage();
    // Setup translations
    this.languageService.init();

    // todo my play
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      let subUrl = event.url.split('/')[1];
      // console.log("event",event);
      //this check if the url is null navigate to user not dashbord
      if (event.url === '/') {
        this.router.navigate(['/dashboard']);
      }
      if (subUrl.indexOf('?') !== -1) {
        subUrl = subUrl.slice(0, subUrl.indexOf('?'));
      }

      let baseParentUrl = 'menu.' + subUrl;
      if (event.url.split('/')[1] === '') {
        baseParentUrl = 'menu.home';
      }
      this.titleService.setTitle('Mardam | ' + this.translateService.instant(baseParentUrl));
    });
  }
  addSvgIcons(iconNames: Array<string>) {
    iconNames.forEach((name: string) => {
      this.matIconRegistry.addSvgIcon(
        name,
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/' + name + '.svg')
      );
    });
  }
}
